<div class="flex flex-col h-full">
  <div class="mb-4 h-[350px] relative">
    <div
      *ngIf="isLoading"
      class="flex items-center justify-center h-full absolute inset-0 bg-surface-0 dark:bg-surface-900"
    >
      <p-progressSpinner ariaLabel="loading" />
    </div>

    <div
      *ngIf="!isLoading && totalComments === 0"
      class="flex flex-col items-center justify-center h-full text-center p-8 absolute inset-0"
    >
      <lucide-icon
        name="message-square"
        [size]="50"
        class="text-gray-300 dark:text-gray-200 mb-4"
      ></lucide-icon>
      <p class="text-base text-gray-500 dark:text-gray-200">
        Aucun commentaire pour le moment
      </p>
    </div>

    <div [class.invisible]="isLoading" class="overflow-y-auto h-full space-y-4">
      <div
        *ngFor="let comment of comments"
        [ngClass]="{
          'bg-blue-50 dark:bg-blue-900/20 border-blue-400 dark:border-blue-600':
            editingCommentId === comment.id,
        }"
        class="flex gap-3 p-3 bg-surface-100 dark:bg-surface-700 rounded-lg border-2 border-surface-200 dark:border-surface-600 shadow-sm transition-all"
      >
        <div
          class="w-10 h-10 rounded-full bg-gray-500 dark:bg-gray-600 flex items-center justify-center text-white font-bold text-sm shrink-0 shadow-md"
        >
          {{ comment.initials }}
        </div>

        <div class="flex-1">
          <div class="flex items-center justify-between mb-1">
            <span class="font-semibold text-sm text-color">{{
              comment.userName
            }}</span>
            <div class="flex items-center gap-2">
              <span class="text-xs text-muted-color">{{
                comment.date | date: "dd/MM/yyyy HH:mm"
              }}</span>
              <button
                *ngIf="canEditComment(comment)"
                (click)="
                  editingCommentId === comment.id
                    ? cancelEdit()
                    : startEditComment(comment)
                "
                [class.text-amber-600]="editingCommentId === comment.id"
                class="text-gray-500"
                [title]="
                  editingCommentId === comment.id
                    ? 'Annuler'
                    : 'Modifier le commentaire'
                "
              >
                <lucide-icon
                  [name]="editingCommentId === comment.id ? 'x' : 'pencil'"
                  [size]="16"
                ></lucide-icon>
              </button>
            </div>
          </div>
          <div
            class="text-sm text-color break-all text-justify whitespace-pre-wrap"
          >
            {{ comment.text }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="totalComments > 0" class="flex justify-center mb-4">
    <p-paginator
      [rows]="pageSize"
      [totalRecords]="totalComments"
      (onPageChange)="onPageChange($event)"
      [showPageLinks]="true"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first} - {last} sur {totalRecords}"
    ></p-paginator>
  </div>

  <div class="flex gap-2">
    <textarea
      *ind4HasRole="'SED_PLUS_REGULAR_USER'"
      #commentTextarea
      [(ngModel)]="newComment"
      (input)="autoResize(commentTextarea)"
      (ngModelChange)="onCommentChange(commentTextarea)"
      rows="2"
      class="flex-1 p-3 border-2 border-surface-300 dark:border-surface-600 rounded-lg resize-none focus:outline-none focus:border-gray-500 bg-surface-0 dark:bg-surface-900 text-color shadow-sm overflow-hidden"
      placeholder="Écrire un commentaire..."
    ></textarea>
    <button
      *ind4HasRole="'SED_PLUS_REGULAR_USER'"
      (click)="isEditMode ? updateComment() : sendComment()"
      [disabled]="!newComment.trim() || isSending"
      class="w-[130px] py-2 bg-gray-800 hover:bg-gray-900 disabled:bg-gray-300 text-white font-semibold rounded-lg h-fit self-end flex items-center gap-2 justify-center"
    >
      <i *ngIf="isSending" class="pi pi-spin pi-spinner"></i>
      {{ isEditMode ? "Modifier" : "Envoyer" }}
    </button>
  </div>
</div>
